// Publish only confirmed backend policy; do not invent retention promises.
export const accountDeletionPolicy = {
  supportEmail: 'canvasandcodefactory@gmail.com',
  deletedData: process.env.REACT_APP_DELETION_DATA_SCOPE || '',
  retainedData: process.env.REACT_APP_DELETION_RETENTION_POLICY || '',
  timeframe: process.env.REACT_APP_DELETION_TIMEFRAME || '',
};

export const deletionPolicyReady = (policy) =>
  [policy.deletedData, policy.retainedData, policy.timeframe].every(
    (value) => typeof value === 'string' && value.trim().length > 0
  );
